<app-pias-layout>
    <div pias-layout-content>
        <!-- <app-marketing-review-nav></app-marketing-review-nav> -->

        <!-- ═══════════ Page head ═══════════ -->
        <div class="page-header-section">

            <!-- Left Content -->
            <div class="page-header-left">

                <div class="header-icon-badge">
                    <mat-icon>rate_review</mat-icon>
                </div>

                <div class="title-wrapper">
                    <h4 class="page-header">
                        {{ isReadOnly ? 'Advertisement Review' : 'Evaluate Advertisement' }}
                    </h4>
                    <p class="page-subtitle">
                        {{ isReadOnly
                        ? 'This review is closed — the decision and comments are shown below.'
                        : 'Score each criterion, share your comments, then record a decision.' }}
                    </p>
                </div>
            </div>

            <!-- Right Actions -->
            <div class="page-header-right">
                <button type="button" class="back-btn" (click)="goBack()">
                    <mat-icon>arrow_back</mat-icon>
                    Back to dashboard
                </button>
            </div>

        </div>

        <div class="review-stage">

            @if (setSprinner()) {
            <div class="pias-spinner">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            }

            @if (notFound) {
            <div class="review-card">
                <div class="review-missing">
                    <mat-icon>error_outline</mat-icon>
                    <p class="review-missing-title">Advertisement not found</p>
                    <p class="review-missing-hint">It may have been removed, or the link is no longer valid.</p>
                    <button type="button" class="btn-primary" (click)="goBack()">Back to dashboard</button>
                </div>
            </div>
            }

            @if (adDetails) {
            <div class="review-card">

                <!-- ═══════════ Header ═══════════ -->
                <div class="review-head">
                    <button type="button" class="icon-btn" aria-label="Back to dashboard" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>

                    <div class="review-head-text">
                        <h1 class="review-title">{{ adDetails.marketingTitle }}</h1>
                        <!-- <p class="review-meta">{{ metaLine }}</p> -->
                    </div>

                    <app-ad-status-badge [status]="normalizeAdStatus(adDetails.status)"></app-ad-status-badge>

                    <span class="review-head-spacer"></span>

                    @if (isReadOnly) {
                    <div class="review-locked">
                        <mat-icon>lock</mat-icon>
                        <span>Review closed</span>
                    </div>
                    } @else {
                    @if(isReviewer && ['Submitted','In_Review'].includes(this.normalizeAdStatus(adDetails.status))){
                    @if(actionFlag()){    
                    <div class="review-actions">
                        <button type="button" class="btn-reject" (click)="reject()">Reject</button>
                        <button type="button" class="btn-changes" (click)="returnForChanges()">Request changes</button>
                        <button type="button" class="btn-approve" (click)="approve()">Approve</button>
                    </div>
                    }
                    }
                    }
                </div>

                <!-- ═══════════ Compare versions ═══════════ -->
                <!-- Full width, in place of the body: two documents need the room more than the
                     comment panel does. Pins show read-only; commenting resumes on exit. -->
                @if (compareGroup; as group) {
                <div class="review-compare">
                    <app-version-compare [versions]="group.versions" [fileName]="group.current.fileName"
                        [comments]="adComments" [leftId]="compareLeftId" [rightId]="compareRightId"
                        (exit)="closeCompare()"></app-version-compare>
                </div>
                } @else {

                <!-- ═══════════ Body ═══════════ -->
                <div class="review-body">

                    <!-- ---- Left: the creative ---- -->
                    <section class="media-pane">

                        <!-- ---- New versions (returned ads, submitter only) ---- -->
                        <!-- Files are never removed or swapped: a correction goes up as a new version
                             of the file it corrects, and earlier versions stay on record. -->
                        @if (canUploadNewVersions) {
                        <div class="revise-card">
                            <div class="revise-head">
                                <mat-icon>undo</mat-icon>
                                <span class="revise-head-text">
                                    <span class="revise-title">Changes requested</span>
                                    <span class="revise-sub">
                                        Upload a new version of each file that needs correcting, then resubmit.
                                        Earlier versions stay on record.
                                    </span>
                                </span>
                            </div>

                            @for (group of mediaGroups; track group.key) {
                            <div class="revise-row">
                                <span class="revise-thumb" [attr.data-tone]="group.current.tone">
                                    <mat-icon>{{ group.current.icon }}</mat-icon>
                                </span>
                                <span class="revise-text">
                                    <span class="revise-name" [matTooltip]="group.current.fileName">
                                        {{ group.current.fileName }}
                                    </span>
                                    <span class="revise-meta">
                                        v{{ group.current.version }}
                                        @if (group.current.openPins) {
                                        · {{ group.current.openPins }} open
                                        {{ group.current.openPins === 1 ? 'pin' : 'pins' }}
                                        }
                                    </span>
                                </span>

                                @if (revisedGroups.has(group.key)) {
                                <span class="revise-done">
                                    <mat-icon>check_circle</mat-icon>
                                    Uploaded
                                </span>
                                }

                                <label class="revise-upload"
                                    [attr.aria-label]="'Upload a new version of ' + group.current.fileName">
                                    <input type="file" hidden [accept]="ACCEPTED_FILE_TYPES"
                                        (change)="onNewVersionSelected($event, group)" />
                                    <mat-icon>upload_file</mat-icon>
                                    {{ revisedGroups.has(group.key) ? 'Upload again' : 'Upload new version' }}
                                </label>
                            </div>
                            } @empty {
                            <p class="revise-empty">This advertisement has no files to revise.</p>
                            }

                            <div class="revise-foot">
                                <span class="revise-count">
                                    {{ revisedGroups.size }} of {{ mediaGroups.length }}
                                    {{ mediaGroups.length === 1 ? 'file' : 'files' }} updated
                                </span>
                                <span class="revise-spacer"></span>
                                <button type="button" class="btn-comment" (click)="resubmitWithNewVersions()">
                                    <mat-icon>send</mat-icon>
                                    Resubmit for review
                                </button>
                            </div>
                        </div>
                        }

                        <!-- ---- Files, each with its versions ---- -->
                        <!-- Corrections are uploaded as new versions rather than overwriting the old,
                             so each file is one card with its versions in a row, oldest to current. -->
                        @if (mediaTabs.length > 1) {
                        <div class="file-groups">
                            @for (group of mediaGroups; track group.key) {
                            <div class="file-group" [class.is-on]="media?.groupKey === group.key">
                                <span class="file-group-thumb" [attr.data-tone]="group.current.tone">
                                    <mat-icon>{{ group.current.icon }}</mat-icon>
                                </span>
                                <div class="file-group-body">
                                    <span class="file-group-name" [matTooltip]="group.current.fileName">
                                        {{ group.current.fileName }}
                                    </span>
                                    <span class="file-group-meta">
                                        {{ group.current.label }} ·
                                        {{ group.versions.length }} {{ group.versions.length === 1 ? 'version' :
                                        'versions' }}
                                    </span>
                                    <div class="version-track" role="group"
                                        [attr.aria-label]="'Versions of ' + group.current.fileName">
                                        @for (tab of group.versions; track tab.attachmentId) {
                                        <button type="button" class="version-chip" [class.is-on]="tab === media"
                                            [class.is-current]="tab.isCurrent" [attr.aria-pressed]="tab === media"
                                            [matTooltip]="tab.fileName + (tab.uploadedOn ? ' · uploaded ' + tab.uploadedOn : '')"
                                            (click)="selectVersion(tab)">
                                            v{{ tab.version }}
                                            @if (tab.isCurrent) {
                                            <span class="version-tag">Current</span>
                                            }
                                            @if (tab.openPins) {
                                            <span class="version-pins">
                                                <mat-icon>push_pin</mat-icon>{{ tab.openPins }}
                                            </span>
                                            }
                                        </button>
                                        }
                                    </div>
                                </div>
                                @if (group.versions.length > 1) {
                                <button type="button" class="file-group-compare" matTooltip="Compare versions"
                                    [attr.aria-label]="'Compare versions of ' + group.current.fileName"
                                    (click)="openCompare(group)">
                                    <mat-icon>compare</mat-icon>
                                </button>
                                }
                            </div>
                            }
                        </div>
                        }

                        <div class="media-toolbar">
                            @if (media) {
                            <span class="media-title">
                                <span class="media-single">{{ media.fileName }}</span>
                                @if (activeGroup && activeGroup.versions.length > 1) {
                                <span class="media-version" [class.is-current]="media.isCurrent">
                                    v{{ media.version }} of {{ activeGroup.versions.length }}
                                </span>
                                }
                            </span>
                            }

                            @if (media && media.kind !== 'image') {
                            <a class="media-open" [href]="media.url" target="_blank" rel="noopener noreferrer"
                                matTooltip="Open in a new tab">
                                <mat-icon>open_in_new</mat-icon>
                            </a>
                            }

                            @if (media && media.pinnable) {
                            <div class="zoom-control">
                                <button type="button" aria-label="Zoom out" [disabled]="!canZoomOut"
                                    (click)="zoomOut()">−</button>
                                <span class="zoom-value">{{ zoom }}%</span>
                                <button type="button" aria-label="Zoom in" [disabled]="!canZoomIn"
                                    (click)="zoomIn()">+</button>
                            </div>
                            }
                        </div>

                        @if (media && !media.isCurrent && activeGroup) {
                        <div class="version-notice">
                            <mat-icon>history</mat-icon>
                            <p class="version-notice-text">
                                Viewing v{{ media.version }}, an earlier version kept for the record.
                                @if (!isReadOnly) {
                                Its pins stay visible; new pins go on the current version.
                                }
                            </p>
                            <button type="button" class="version-notice-btn" (click)="openCompare(activeGroup, media)">
                                <mat-icon>compare</mat-icon>
                                Compare with current
                            </button>
                            <button type="button" class="version-notice-btn" (click)="showCurrentVersion()">
                                View current (v{{ activeGroup.current.version }})
                            </button>
                        </div>
                        }

                        @if (media) {
                        <div class="media-frame">
                            <!-- PDF, images, Word, Excel and PowerPoint render in the browser, where
                                 the reviewer can pin comments to text or an area — on the current
                                 version only; earlier versions are the record of past rounds. -->
                            @if (media.pinnable) {
                            <app-pin-viewer [src]="media.url" [fileName]="media.fileName" [kind]="media.kind"
                                [zoom]="zoom" [pins]="mediaPins" [activePinId]="activePinId" [draft]="mediaDraft"
                                [readOnly]="isReadOnly || !media.isCurrent" (pinDraft)="onPinDraft($event)"
                                (pinSelect)="onPinSelect($event)"></app-pin-viewer>
                            } @else {
                            @switch (media.kind) {

                            @case ('video') {
                            <div class="media-plate is-video">
                                <video [src]="media.url" controls preload="metadata"></video>
                                <p class="media-note">
                                    Playback is scoped to review only. Feedback goes in the comment thread.
                                </p>
                            </div>
                            }

                            <!-- Legacy .doc / .ppt and anything else with no in-browser renderer. -->
                            @default {
                            <div class="media-doc" [attr.data-tone]="media.tone">
                                <span class="media-doc-disc">
                                    <mat-icon>{{ media.icon }}</mat-icon>
                                </span>
                                <p class="media-doc-name">{{ media.fileName }}</p>
                                <p class="media-doc-meta">{{ media.meta }}</p>
                                <p class="media-note">
                                    This format cannot be previewed here — older .doc and .ppt files need to be
                                    saved as .docx or .pptx to pin comments on them. Open the file to review it,
                                    then record your decision here.
                                </p>
                                <a class="media-doc-open" [href]="media.url" target="_blank" rel="noopener noreferrer">
                                    <mat-icon>open_in_new</mat-icon> Open file
                                </a>
                            </div>
                            }
                            }
                            }
                        </div>
                        } @else {
                        <div class="media-unsupported">
                            <mat-icon>image_not_supported</mat-icon>
                            <p>No creative was attached to this submission.</p>
                        </div>
                        }

                        <!-- ---- Application details ---- -->
                        <!-- Only what the application form actually collects; the uncollected
                             `SaveAdPayload` fields would read as blanks. -->
                        <details class="copy-card" open>
                            <summary class="copy-summary">
                                <mat-icon>subject</mat-icon> Application details
                            </summary>

                            <dl class="copy-list">
                                <dt>Branch name</dt>
                                <dd>{{ adDetails.branchName }}</dd>

                                <dt>Date of application</dt>
                                <dd>{{ adDetails.createdDate }}</dd>

                                <dt>Target recipient(s)</dt>
                                <dd>{{ adDetails.targetRecepients || '—' }}</dd>

                                <dt>Expected date of dissemination</dt>
                                <dd>
                                    @if (adDetails.expectedDateOfDissemination) {
                                    {{ adDetails.expectedDateOfDissemination }}
                                    } @else if (adDetails.expectedCommentOfDissemination) {
                                    {{ adDetails.expectedCommentOfDissemination }}
                                    } @else {
                                    —
                                    }
                                </dd>

                                <dt>Mode of dissemination</dt>
                                <dd>{{ adDetails.modeOfDissemination || '—' }}</dd>
                            </dl>
                        </details>
                        @if(isReviewer){
                        <details class="copy-card" open [formGroup]="marketingReviewApproveformGroup">
                            <summary class="copy-summary">
                                <mat-icon>fact_check</mat-icon> Acknowledgement
                                <span class="ack-count">{{ checklistItems.length }} checks</span>
                            </summary>

                            <div class="ack-confirm">
                                <mat-checkbox formControlName ='ConcentCheck'>
                                    <span class="ack-confirm-label">I confirm that I have checked the following:</span>
                                </mat-checkbox>
                            </div>

                            <ol class="ack-list">
                                @for (item of checklistItems; track item.id) {
                                <li>{{ item.title }}</li>
                                }
                            </ol>
                        </details>
                        }
                    </section>

                    <!-- ---- Right: the reviewer's panel ---- -->
                    <aside class="review-panel">

                        <div class="panel-head">
                            <h2 class="panel-title">Comments</h2>
                            @if (pinTotal) {
                            <span class="panel-pins" matTooltip="Pinned comments still open / pinned in total">
                                <mat-icon>push_pin</mat-icon>
                                {{ pinOpen }} open / {{ pinTotal }}
                            </span>
                            }
                            <span class="panel-count">
                                {{ threadCount }}
                                {{ threadCount === 1 ? 'entry' : 'entries' }}
                            </span>
                        </div>

                        <!-- ---- Thread: comments and decisions, in time order ---- -->
                        <div class="panel-scroll">
                            @if (thread.length) {
                            @for (entry of thread; track entry.key) {

                            @if (entry.kind === 'comment') {
                            <div class="comment is-note" [id]="'thread-comment-' + entry.comment.adId"
                                [class.is-pinned]="entry.comment.pin" [class.is-resolved]="isResolved(entry.comment)"
                                [class.is-active]="entry.comment.pin && activePinId === entry.comment.adId">
                                <div class="comment-head">
                                    <span class="comment-avatar">{{ initialsOf(entry.comment.commentedBy) }}</span>
                                    <span class="comment-who">
                                        <span class="comment-name">{{ entry.comment.commentedBy }}</span>
                                        <span class="comment-role">
                                            {{ entry.comment.userRole }} ·
                                            {{ entry.comment.createdDate }}
                                            @if (entry.comment.updatedDate) {
                                            · edited
                                            }
                                        </span>
                                    </span>

                                    @if (canModify(entry.comment) && editingCommentId !== entry.comment.adId) {
                                    <span class="comment-actions">
                                        <button type="button" class="comment-action" matTooltip="Edit comment"
                                            (click)="startEdit(entry.comment)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button type="button" class="comment-action is-danger"
                                            matTooltip="Delete comment" (click)="deleteComment(entry.comment)">
                                            <mat-icon>delete_outline</mat-icon>
                                        </button>
                                    </span>
                                    }
                                </div>

                                @if (editingCommentId === entry.comment.adId) {
                                <div class="comment-edit">
                                    <textarea rows="3" maxlength="1500" [(ngModel)]="editingText"></textarea>
                                    <div class="comment-edit-actions">
                                        <button type="button" class="btn-comment"
                                            (click)="saveEdit(entry.comment)">Save</button>
                                        <button type="button" class="btn-comment-ghost"
                                            (click)="cancelEdit()">Cancel</button>
                                    </div>
                                </div>
                                } @else {
                                @if (entry.comment.pin; as pin) {
                                <div class="pin-meta">
                                    <span class="pin-no">{{ entry.comment.pinNo }}</span>
                                    <button type="button" class="pin-ref" matTooltip="Show on the material"
                                        (click)="focusPin(entry.comment)">
                                        <mat-icon>my_location</mat-icon>
                                        {{ pinLocation(pin) }}
                                    </button>
                                    <span class="pin-status" [class.is-resolved]="isResolved(entry.comment)">
                                        {{ entry.comment.status }}
                                    </span>
                                </div>
                                @if (pin.quote) {
                                <blockquote class="pin-quote" (click)="focusPin(entry.comment)">{{ pin.quote }}
                                </blockquote>
                                }
                                }
                                <!-- Only a reply whose comment was deleted reaches the top level; it
                                     quotes what it answered so it still reads in context. -->
                                @if (entry.comment.replyId && entry.comment.replyComment) {
                                <blockquote class="reply-quote">
                                    <span class="reply-quote-label">Replying to</span>
                                    {{ entry.comment.replyComment }}
                                </blockquote>
                                }
                                <p class="comment-body">{{ entry.comment.text }}</p>
                                }

                                @if (entry.comment.pin && isResolved(entry.comment) && entry.comment.resolvedBy) {
                                <p class="pin-resolved-by">
                                    Resolved by {{ entry.comment.resolvedBy }} ·
                                    {{ entry.comment.resolvedDate | date:'d MMM, h:mm a':'+0800' }}
                                </p>
                                }

                                <!-- ---- Replies, in the order they were made ---- -->
                                @if (entry.replies.length) {
                                <ul class="pin-replies" [attr.aria-label]="'Replies to ' + entry.comment.commentedBy">
                                    @for (reply of entry.replies; track reply.adId) {
                                    <li class="pin-reply" [id]="'thread-comment-' + reply.adId">
                                        <span class="comment-avatar is-small">{{ initialsOf(reply.commentedBy) }}</span>
                                        <span class="pin-reply-body">
                                            <span class="comment-name">{{ reply.commentedBy }}</span>
                                            <span class="comment-role">
                                                {{ reply.userRole }} ·
                                                {{ reply.createdDate }}
                                                @if (reply.updatedDate) {
                                                · edited
                                                }
                                            </span>
                                            <span class="pin-reply-text">{{ reply.text }}</span>
                                        </span>
                                    </li>
                                    }
                                </ul>
                                }

                                @if (entry.comment.pin) {
                                @if (!isReadOnly) {
                                <div class="pin-reply-box">
                                    <input type="text" maxlength="1000" placeholder="Reply…"
                                        [(ngModel)]="replyText[entry.comment.adId]"
                                        (keydown.enter)="postReply(entry.comment)" />
                                    <button type="button" class="btn-comment-ghost"
                                        [disabled]="!replyText[entry.comment.adId]?.trim()"
                                        (click)="postReply(entry.comment)">Reply</button>
                                </div>
                                @if(canModify(entry.comment) && editingCommentId !== entry.comment.adId){
                                <div class="pin-actions">
                                    @if (isResolved(entry.comment)) {
                                    <button type="button" class="pin-action"
                                        (click)="setPinStatus(entry.comment, 'open')">
                                        <mat-icon>undo</mat-icon> Reopen
                                    </button>
                                    } @else {
                                    <button type="button" class="pin-action is-resolve"
                                        (click)="setPinStatus(entry.comment, 'resolved')">
                                        <mat-icon>check_circle_outline</mat-icon> Resolve
                                    </button>
                                    }
                                </div>
                                }
                                }
                                }
                            </div>
                            }

                            }
                            } @else {
                            <p class="panel-empty">No comments yet — start the conversation below.</p>
                            }
                        </div>

                        <!-- ---- Composer ---- -->
                        @if (!isReadOnly) {
                        <div class="composer">
                            <div class="composer-box" [class.is-invalid]="commentsInvalid">
                                <!-- A pin placed on the material waits here until the comment is shared. -->
                                @if (draftPin) {
                                <div class="composer-pin">
                                    <mat-icon>push_pin</mat-icon>
                                    <span class="composer-pin-text">
                                        {{ pinLocation(draftPin) }}
                                        @if (draftPin.quote) {
                                        · “{{ draftPin.quote }}”
                                        }
                                    </span>
                                    <button type="button" class="comment-action" matTooltip="Discard pin"
                                        (click)="discardDraftPin()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                }
                                <textarea #composerInput rows="3" maxlength="1500" [(ngModel)]="overallComments"
                                    (blur)="commentsTouched = true"
                                    [placeholder]="draftPin
                                        ? 'What needs to change here?'
                                        : 'Share your thoughts with the branch — what works, what needs to change, and why'"></textarea>

                                <div class="composer-foot">
                                    <span class="composer-count">{{ overallComments.length }}/1500</span>

                                    <!-- Shares the comment on its own; the decision buttons are in the header. -->
                                    <button type="button" class="btn-comment" [disabled]="!overallComments.trim()"
                                        (click)="postComment()">
                                        <mat-icon>send</mat-icon>
                                        Comment
                                    </button>
                                </div>
                            </div>

                            @if (commentsInvalid) {
                            <p class="composer-error">Please share your comments before recording a decision</p>
                            } @else {
                            <p class="composer-hint">Visible to the submitter and the marketing team</p>
                            }
                        </div>
                        }
                    </aside>
                </div>
                }
            </div>
            }
        </div>
    </div>
</app-pias-layout>